import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, input, output, ViewEncapsulation } from '@angular/core';
import { EnpsControlComponent } from '@common/controls/enps-control/enps-control';

export type DeskItem = { id: string; title: string; selectable: boolean; initials?: string };

@Component({
    selector: 'st-topic-button',
    templateUrl: './topic-button.html',
    styleUrls: ['./topic-button.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'st-topic-button',
    },
})
export class TopicButtonComponent extends EnpsControlComponent<string> {
    label = input<string>('');
    value = input<string>('');

    inFullScreenMode = input(false, {
        transform: coerceBooleanProperty,
    });

    topicOpenEmitter = output();

    constructor() {
        super();
    }
}
